/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/alt-text */
import { IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import React from 'react';

import type { VotingCardProps } from '../../../movie/card/VotingCard.component';
import { VotingCard } from '../../../movie/card/VotingCard.component';
import { Panel } from '../../panel/Panel.component';
import styles from './VoteModal.module.css';

export interface VoteModalProps extends VotingCardProps {
  name: string;
  studio: string;
  image: string;
  synopsis: string;
  cast: { role: string; name: string }[];
}
export interface VoteProps extends VoteModalProps {
  hideModal: () => void;
}

const SmartText = (text: string, length: number = 20) => {
  const [showLess, setShowLess] = React.useState(true);

  if (text.length < length) {
    return (
      <div className={styles.description}>
        <span className="text-white">{text}</span>
      </div>
    );
  }

  return (
    <div className={styles.description}>
      <span className="text-white">
        {showLess ? `${text.slice(0, length)}` : `${text} `}
      </span>
      <button
        className={styles.descriptionRead}
        onClick={() => setShowLess(!showLess)}
      >
        {showLess ? '... Read More' : 'Read Less'}
      </button>
    </div>
  );
};

const Vote: React.FC<VoteProps> = ({
  image,
  name,
  synopsis,
  studio,
  cast,
  hideModal,

  ...movieVotingCardProps
}: VoteProps) => {
  const castList = cast.map((actor, i) => {
    return (
      <div key={actor.name + i.toString()}>
        <div className={styles.castLabel}>{actor.role}</div>
        <div className={styles.cast}>{actor.name}</div>
      </div>
    );
  });

  return (
    <Panel
      className="overflow-hidden w-full"
      bodyClassName={styles.panel + ' flex flex-col rounded-lg max-w-5xl '}
    >
      <div className="flex flex-row w-full">
        <div
          className={
            styles.movieInfo + ' flex flex-col md:ml-6 my-6 md:w-1/2 w-0'
          }
        >
          <div className="flex lg:flex-row flex-col">
            <img src={image} className={styles.image + ' w-2/5 '} />
            <div className="flex flex-col lg:w-3/5 w-full">
              <div className={styles.title}>{name}</div>
              <div className={styles.studio}>{studio}</div>
              {SmartText(synopsis, 350)}
            </div>
          </div>
          <div className="">
            <div className={styles.castTitle}>Team</div>
            <div className="grid grid-flow-row lg:grid-cols-4 grid-cols-3 gap-4">
              {castList}
            </div>
          </div>
        </div>
        <div
          className={
            styles.form + ' flex flex-col md:ml-4 relative md:w-1/2 w-full'
          }
        >
          <IconButton
            className={'h-10 w-10 top-4 right-4 z-30'}
            style={{
              background: '#000000',
              border: 'none',
              position: 'absolute',
            }}
            onClick={hideModal}
          >
            <ClearIcon style={{ color: 'white' }} />
          </IconButton>
          <VotingCard hideModal={hideModal} {...movieVotingCardProps} />
        </div>
      </div>
    </Panel>
  );
};

export const VoteModal =
  (props: VoteModalProps) =>
  ({ hideModal }: VoteProps) => {
    return <Vote hideModal={hideModal} {...props} />;
  };
